import React from 'react';

const Field = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <label className="block mb-3"><span className="block text-xs text-gray-500 mb-1">{label}</span>{children}</label>
);
export default Field;
